import { render, staticRenderFns } from "./NotAuthorizeEditor.vue?vue&type=template&id=1ac229f7&scoped=true&"
import script from "./NotAuthorizeEditor.vue?vue&type=script&lang=js&"
export * from "./NotAuthorizeEditor.vue?vue&type=script&lang=js&"
import style0 from "./NotAuthorizeEditor.vue?vue&type=style&index=0&id=1ac229f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac229f7",
  null
  
)

export default component.exports